module.exports = __webpack_public_path__ + "static/media/avatar.ab879435.svg";